import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import BookingPage from "./pages/BookingPage";
import JeepSafariPage from "./pages/JeepSafariPage";
import CanterSafariPage from "./pages/CanterSafariPage";
import SafariBookingPage from "./pages/SafariBookingPage";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import BookingProcess from "./pages/BookingProcess";
import TermsConditions from "./pages/TermsConditions";

import { initGA, trackPageView } from "./components/Analytics";

// 👇 This component tracks route changes
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
}

export default function App() {

  useEffect(() => {
    initGA(); // initialize once
  }, []);

  return (
    <BrowserRouter>

      <AnalyticsTracker />  {/* 🔥 Add this */}

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<BookingPage />} />
        <Route path="/jeep-safari-ranthambore" element={<JeepSafariPage />} />
        <Route path="/canter-safari-ranthambore" element={<CanterSafariPage />} />
        <Route path="/ranthambore-safari-booking" element={<SafariBookingPage />} />
        <Route path="/about-us" element={<AboutUs />} />  
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/booking-process" element={<BookingProcess />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        
I am the sole proprietor of Ranthambore Safari Booking Assistance, a government-registered Micro-enterprise in India (UDYAM-HR-05-0182921). I provide travel consultancy and safari booking facilitation services.

I operate with full transparency. My website clearly discloses that I am a private travel assistance service and not affiliated with any government authority. I use my registered business name consistently and do not misrepresent myself as an official booking portal.

I have attached my MSME (Udyam) Registration Certificate and PAN Card,Aadhar Card to verify my identity and business legitimacy. I am committed to complying fully with Google Ads policies and maintaining accurate and transparent business practices.

      </Routes>

      <Footer />

    </BrowserRouter>
  );
}